import {HTTP, ERROR, getUserInfo} from '@/http-common';
import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import Router from '@/router';
import FileSaver from 'file-saver';

const state = {
  activity_feed: {},
  reports: [],
  templates: [],
  forms: [],
  fields_report: {},
  current_report: {},
  preview: {},
  loading: {
    edit: false,
    forms: false,
    fields: false,
    reports: false,
    list: false,
    summaryIndex: false,
    chartsIndex: false
  },
  generatingReport: false,
  folders: [],
  parentFolder: null,
  folderId: null,
  folder: null,
  path: [],
  accountFolders: [],
  reportsCount: 0,
  topReportsIds: [],
  topReports: [],
  summaryIndex: [],
  chartsIndex: []
};

const mutations = {
  SET_REPORTS(state, data) {
    state.reports = data;
  },
  SET_FOLDERS(state, data) {
    state.folders = data;
  },
  SET_FOLDER(state, data) {
    state.folder = data;
  },
  SET_PARENT_FOLDER(state, data) {
    state.parentFolder = data;
  },
  SET_REPORT(state, data) {
    state.current_report = data;
  },
  SET_REPORT_PREVIEW(state, date) {
    state.preview = date;
  },
  SET_FORMS(state, data) {
    state.forms = data;
  },
  SET_REPORT_FIELDS(state, data) {
    state.fields_report = data;
  },
  SET_TEMPLATES(state, data) {
    state.templates = data;
  },
  SET_ACCOUNT_FOLDERS(state, data) {
    state.accountFolders = data;
  },
  SET_REPORTS_COUNT(state, data) {
    state.reportsCount = data;
  },
  SET_FOLDER_ID(state, data) {
    state.folderId = data;
  },
  SET_PATH(state, data) {
    state.path = data;
  },
  SET_TOP_REPORTS_IDS(state, data) {
    state.topReportsIds = data;
  },
  SET_TOP_REPORTS(state, data) {
    state.topReports = data;
  },
  SET_SUMMARY_INDEX(state, data) {
    state.summaryIndex = data;
  },
  SET_CHARTS_INDEX(state, data) {
    state.chartsIndex = data;
  }
};

const getters = {
  getReports: state => state.reports,
  getReport: state => state.current_report,
  getReportPreview: state => state.preview,
  getReportsLoading: state => state.loading,
  getReportGenerating: state => state.generatingReport,
  getFieldsReportInOrder: state => state.fields_report,
  getFormsInOrder: state => {
    if (!state.forms ) {
      return [];
    }
    return _.orderBy(state.forms, [item => item.name.toLowerCase()], ['asc'])
  },
  getFolders: state => state.folders,
  getFolder: state => state.folder,
  getParentFolder: state => state.parentFolder,
  getAccountFolders: state => state.accountFolders,
  getReportsCount: state => state.reportsCount,
  getPath: state => state.path,
  getTopReportsIds: state => state.topReportsIds,
  getTopReports: state => state.topReports,
  getReportSummaryIndex: state => state.summaryIndex,
  getChartsIndex: state => state.chartsIndex
};

const actions = {
  SET_FOLDER_ID_ACTION: ({commit}, payload) => {
    commit('SET_FOLDER_ID', payload);
  },
  GET_REPORTS_LIST_ACTION: ({commit}, payload) => {
    state.loading.list = true;
    HTTP.post(`reports`, {type: payload.type, folder: state.folderId})
      .then(response => {
        ERROR(response);
        commit('SET_REPORT', {})
        if (response.data.status == 'success') {
          if (payload.type == 'report') {
            commit('SET_REPORTS', response.data.data.reports);
            commit('SET_FOLDER', response.data.data.folder);
            commit('SET_FOLDERS', response.data.data.folders);
            commit('SET_PARENT_FOLDER', response.data.data.parentFolder);
            commit('SET_REPORTS_COUNT', response.data.data.count);
            commit('SET_PATH', response.data.data.path);
            commit('SET_TOP_REPORTS_IDS', response.data.data.top_reports_ids);
            state.loading.list = false;
          } else {
            commit('SET_TEMPLATES', response.data.data);
            state.loading.list = false;
          }
        }
      })
      .catch(err => {
        console.log(err)
      });
  },
  GET_ACCOUNT_FOLDERS_ACTION: ({commit}, payload) => {
    HTTP.post('reports/account-folders')
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_ACCOUNT_FOLDERS', response.data.data.folders);
        }
      })
      .catch(err => {
        console.log(err)
      });
  },
  DELETE_REPORT_ACTION: ({commit, dispatch}, payload) => {
    HTTP.post(`reports/delete`, {id: payload})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
          Vue.prototype.$notify('Report deleted.');
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err)
      });
  },
  CHANGE_STATUS_REPORT_ACTION: ({commit, dispatch}, payload) => {
    HTTP.post(`reports/status`, {id: payload})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
          Vue.prototype.$notify('Status changed.');
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err)
      });
  },
  DUPLICATE_REPORT_ACTION: ({commit, dispatch}, payload) => {
    payload.context.start();
    return HTTP.post(`reports/duplicate`, {id: payload.id, name: payload.name, description: payload.description})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          Vue.prototype.$notify('Report duplicated.');
          dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        payload.context.stop();
      })
      .catch(err => {
        payload.context.stop();
        console.log(err)
      });
  },
  ADD_REPORT_ACTION: ({commit, dispatch}, payload) => {
    state.generatingReport = true;
    HTTP.post(`reports/add`, {
      name: state.current_report.name,
      description: state.current_report.description,
      data: payload.data,
      mode: payload.mode,
      folder_id: payload.folderId,
      accounts: payload.accounts
    }).then(response => {
      ERROR(response);
      state.generatingReport = false;
      state.current_report = {};
      if (response.data.status == 'success') {
        Vue.prototype.$notify('Report created.');
        Router.push({name: 'Reports Preview', params: {reportid: response.data.data.id}});
      } else {
        Vue.prototype.$notify({
          type: 'error',
          text: response.data.message
        });
      }
    })
      .catch(err => {
        console.log(err)
      });
  },
  EDIT_REPORT_ACTION: ({commit}, payload) => {
    HTTP.post(`reports/edit`, {
      id: payload.id,
      name: state.current_report.name,
      description: state.current_report.description,
      data: payload.data,
      mode: payload.mode,
      accounts: payload.accounts
    }).then(response => {
      ERROR(response);
      if (response.data.status == 'success') {
        Vue.prototype.$notify('Report saved.');
        Router.push({name: 'Reports Preview', params: {reportid: response.data.data.id}});
      } else {
        Vue.prototype.$notify({
          type: 'error',
          text: response.data.message
        });
      }
    })
      .catch(err => {
        console.log(err)
      });
  },
  GET_REPORT_EDIT_ACTION: ({commit, dispatch}, payload) => {
    state.loading.edit = true;
    HTTP.post(`reports/get`, {id: payload})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          state.loading.edit = false;
          let reportData = response.data.data;
          if (!reportData.mode || reportData.mode === 0) {
            reportData.mode = 1;
          }
          commit('SET_REPORT', reportData);
          dispatch('GET_FORMS_ACTION', { mode: reportData.mode })
        }
      })
      .catch(err => {
        console.log(err)
      });
  },
  GET_REPORT_ACTION: ({commit}, payload) => {
    state.loading.reports = true;
    let target, url;

    if (payload.report == null) {
      target = {
        id: payload.id,
        offset: payload.offset,
        limit: payload.limit,
        sortBy: payload.sortBy,
        sortDir: payload.sortDir,
        mode: payload.mode,
        accounts: payload.accounts
      };
      url = `reports/result`
    } else {
      target = {
        data: payload.report,
        name: 'preview',
        description: 'description',
        offset: payload.offset,
        limit: payload.limit,
        sortBy: payload.sortBy,
        sortDir: payload.sortDir,
        mode: payload.mode,
        accounts: payload.accounts
      };
      url = `reports/preview`
    }

    HTTP.post(url, target)
      .then(response => {
        state.loading.reports = false;
        ERROR(response);
        if (response.data.status == 'success') {
          let reportData = response.data.data;
          if (!reportData.hasOwnProperty('mode') || !reportData.mode) {
            reportData.mode = 1;
          }
          if (payload.report == null) {
            reportData.id = payload.id;
            commit('SET_REPORT', reportData);
          } else {
            commit('SET_REPORT_PREVIEW', reportData);
          }
          if (reportData.isPreview && payload.report !== null && payload.id) {
            target.generateReport = true;
            state.generatingReport = true;
            HTTP.post('reports/result', target).then(response => {
              reportData = response.data.data;
              commit('SET_REPORT', reportData);
              state.generatingReport = false;
            }).catch(error => {

            });
          }

        }
      })
      .catch(err => {
        state.loading.reports = false;
        console.log(err)
      });
  },
  GET_FORMS_ACTION: ({commit}, payload) => {
    state.loading.forms = true;
    HTTP.get('reports/index-forms/' + payload.mode)
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_FORMS', response.data.data.forms);
          state.loading.forms = false;
        }
      })
      .catch(err => {
        console.log(err)
        state.loading.forms = false;
      });
  },
  GET_FORMS_FIELDS_ACTION: ({commit}, payload) => {
    state.loading.fields = true;
    HTTP.post(`form/getByIds`, {ids: payload})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_REPORT_FIELDS', response.data.data);
          state.loading.fields = false;
        }
      })
      .catch(err => {
        state.loading.fields = false;
        console.log(err);
      });
  },
  ACTIVITY_FEED_REPORT_ACTION: ({commit}, payload) => {
    HTTP.get(`activities/export?from=${payload.from ? payload.from : ''}&to=${payload.to ? payload.to : ''}`)
      .then(response => {
        ERROR(response);
        let current_time;
        const local = moment.tz(new Date(), 'Etc/GMT-0');
        current_time = local.clone().tz(payload.timezone).format(getUserInfo('date_format') + '_hh:mm_A');
        var blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `ActivityFeeds_${current_time}.csv`);
      }).catch(err => {
      console.log(err);
    })
  },
  CASE_NOTES_REPORT_ACTION: ({commit}, payload) => {
    HTTP.get(`notes/export?participant_id=${payload.id}`)
      .then(response => {
        ERROR(response);
        let current_time;
        const local = moment.tz(new Date(), 'Etc/GMT-0');
        current_time = local.clone().tz(payload.timezone).format(getUserInfo('date_format') + '_hh:mm_A');
        var blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `CommunicationNotes_${current_time}.csv`);
      }).catch(err => {
      console.log(err);
    })
  },
  ACCOUNT_LIST_REPORT_ACTION: ({commit}, payload) => {
    return HTTP.get(`accounts/export?search=${payload.search}`)
      .then(response => {
        ERROR(response);
        let current_time;
        const local = moment.tz(new Date(), 'Etc/GMT-0');
        current_time = local.clone().tz(payload.timezone).format(getUserInfo('date_format') + '_hh:mm_A');
        var blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `AccountList_${current_time}.csv`);
      }).catch(err => {
      console.log(err);
    })
  },
  ACCOUNT_USERS_LIST_REPORT_ACTION: ({commit}, payload) => {
    return HTTP.get(`accounts/export/users?search=${payload.search}`)
      .then(response => {
        ERROR(response);
        let current_time;
        const local = moment.tz(new Date(), 'Etc/GMT-0');
        current_time = local.clone().tz(payload.timezone).format(getUserInfo('date_format') + '_hh:mm_A');
        var blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `AccountUsersList_${current_time}.csv`);
      }).catch(err => {
      console.log(err);
    })
  },
  SMS_MESSAGES_REPORT_ACTION: ({commit}, payload) => {
    HTTP.get(`messages/export?search=${payload.search}&id=${payload.id}`)
      .then(response => {
        ERROR(response);
        let current_time;
        const local = moment.tz(new Date(), 'Etc/GMT-0');
        current_time = local.clone().tz(payload.timezone).format(getUserInfo('date_format') + '_hh:mm_A');
        var blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `MessagesList_${current_time}.csv`);
      }).catch(err => {
      console.log(err);
    })
  },
  CREATE_FOLDER_ACTION: ({commit, dispatch}, payload) => {
    let parentId = null;
    if (state.folder) {
      parentId = state.folder.id;
    }
    state.loading.list = true;
    HTTP.post('/reports/create-folder', {
      name: payload.name,
      parentId: parentId
    }).then(response => {
      dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
    })
  },
  DELETE_FOLDER_ACTION({commit, dispatch}, payload) {
    state.loading.list = true;
    HTTP.post('/reports/delete-folder', {
      folder_id: payload.folderId,
      delete_content: payload.deleteFolderContent
    }).then(response => {
      dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
    });
  },
  MOVE_TO_FOLDER_ACTION({commit, dispatch}, payload) {
    // prevent moving folder to itself
    if (payload.itemType === 'folder' && payload.itemId === payload.folderId) {
      return;
    }
    if (!payload.folderId) {
      return;
    }
    state.loading.list = true;
    HTTP.post('/reports/move-to-folder', {
      'item_type': payload.itemType,
      'item_id': payload.itemId,
      'folder_id': payload.folderId
    }).then(response => {
      dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
    });
  },
  EDIT_FOLDER_ACTION({commit, dispatch}, payload) {
    state.loading.list = true;
    HTTP.post('/reports/edit-folder', {
      'id': payload.folderId,
      'name': payload.newName
    }).then(response => {
      dispatch('GET_REPORTS_LIST_ACTION', {type: 'report'});
    })
  },
  SAVE_TOP_REPORTS_ACTION({commit, dispatch}, payload) {
    state.loading.list = true;
    HTTP.post('/reports/save-top-reports', {
      'ids': payload.reportsIds
    }).then(response => {
      if (response.data.status === 'success') {
        state.loading.list = false;
        Vue.prototype.$notify(response.data.data.message);
        commit('SET_TOP_REPORTS_IDS', response.data.data.top_reports_ids);
      }
    }).catch(err => {
      state.loading.list = false;
      console.log(err);
    })
  },
  GET_TOP_REPORTS_LIST_ACTION: ({commit}, payload) => {
    state.loading.list = true;
    HTTP.post(`/reports/index-top-reports`)
      .then(response => {
        ERROR(response);
        commit('SET_TOP_REPORTS', {})
        if (response.data.status == 'success') {
          commit('SET_TOP_REPORTS', response.data.data.reports);
          commit('SET_TOP_REPORTS_IDS', response.data.data.top_reports_ids);
          state.loading.list = false;
        }
      })
      .catch(err => {
        console.log(err)
      });
  },
  fetchSummaryIndex: ({commit}, payload) => {
    state.loading.summaryIndex = true;
    HTTP.post('report-summary/index', {
      'report_id': payload.reportId
    }).then(response => {
      commit('SET_SUMMARY_INDEX', response.data.data.index);
    }).catch(err => {
      Vue.prototype.$notify({
        text: 'Something went wrong while fetching summary.',
        type: 'error'
      })
    }).finally(() => {
      state.loading.summaryIndex = false;
    })
  },
  fetchChartsIndex: ({commit}, payload) => {
    state.loading.chartsIndex = true
    let reportId = payload.reportId;
    HTTP.get('report/' + reportId + '/charts').then(response => {
      ERROR(response);
      commit('SET_CHARTS_INDEX', response.data.data.charts);
    }).catch(error => {
      Vue.prototype.$notify({
        text: 'Something went wrong while fetching charts data.',
        type: 'error'
      });
    }).finally(() => {
      state.loading.chartsIndex = false;
    })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/reports.js